// these come from webpack
declare const CONFIG_API_URL: string;
declare const CONFIG_SENTRY_DSN: string;
declare const CONFIG_SENTRY_RELEASE: string;

export const apiURL = CONFIG_API_URL;
export const sentryDSN = CONFIG_SENTRY_DSN;
export const sentryRelease = CONFIG_SENTRY_RELEASE;



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/config.ts